import React, { Fragment, useRef, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';
const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;

let menuTopLinkIndex = 0;

const GetImageLinks = ({ links, clickedIndex, setClickedIndex }) => {
  if (links.length > 0 && links[0].imageUrl?.length) {
    return (
      <Fragment>
        <section className="row large-up-4 main-menu__images">
          {links.length > 0 &&
            links.map(
              (link, index) =>
                hasNameOrChildren(link) && (
                  <div
                    className="column"
                    key={`navimage${index}{menuTopLinkIndex}`}
                  >
                    <label
                      htmlFor={`main-menu__images-radio${index}${menuTopLinkIndex}`}
                      className={`${clickedIndex === index ? 'active' : ''}`}
                      onClick={() => {
                        setClickedIndex(index);
                      }}
                    >
                      <figure>
                        <a href={link.url}>
                          <img src={link.imageUrl} alt={link.extraInfo} />
                          <figcaption>{link.name}</figcaption>
                        </a>
                      </figure>
                    </label>
                  </div>
                )
            )}
        </section>
      </Fragment>
    );
  }
  return null;
};

const NavigationItem = ({
  links = [],
  contentLink = null,
  subLevel = 0,
  fullMenu,
}) => {
  const menuRef = useRef(null);
  const [mainMenuActive, setMainMenuActive] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(false);

  const toggleMenu = (e, isTopIcon = false) => {
    e.preventDefault();
    const classList = menuRef?.current?.classList;
    if (classList) {
      if (isTopIcon) {
        e.target.classList.toggle('navbar__menu--show');
        const $bodyEl = document.querySelector('body');
        if ($bodyEl) {
          if ($bodyEl.classList.contains('navbar__mobile-menu--active')) {
            const $activeMenu = document.querySelectorAll(
              '.navbar__menu--show'
            );

            if ($activeMenu) {
              $activeMenu.forEach((menu) => {
                menu.classList.remove('navbar__menu--show');
              });
            }
            $bodyEl.classList.toggle('navbar__mobile-menu--active');
            setMainMenuActive(false);
            return;
          }
          $bodyEl.classList.toggle('navbar__mobile-menu--active');
        }
      }
      classList.toggle('navbar__menu--show');
    }
    setMainMenuActive(!mainMenuActive);
  };
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;

  const getLowerLevelLinkCountClass = (amount) => {
    if (amount > 40) {
      return 'large';
    } else if (amount > 20) {
      return 'medium';
    }
    return 'small';
  };
  menuTopLinkIndex++;

  const checkClickedIndex = (index) => {
    if (index !== clickedIndex) {
      setClickedIndex(index);
    }
    // : null
  };

  if (!contentLink && links?.length < 1) {
    return null;
  }

  return (
    <Fragment>
      <div id="quickSearchNew"></div>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={(e) => toggleMenu(e, true)}
          rel="nofollow"
          href="#"
          title={translate('general.menu') || 'menu'}
        >
          {mainMenuActive ? (
            <svg
              className="header__menu-close-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 15.5 15.5"
            >
              <path
                d="m.15.3l.07-.08C.49-.05.9-.07,1.2.15l.08.07,6.47,6.47L14.22.22c.29-.29.77-.29,1.06,0,.29.29.29.77,0,1.06l-6.47,6.47,6.47,6.47c.27.27.29.68.07.98l-.07.08c-.27.27-.68.29-.98.07l-.08-.07-6.47-6.47L1.28,15.28c-.29.29-.77.29-1.06,0-.29-.29-.29-.77,0-1.06l6.47-6.47L.22,1.28C-.05,1.01-.07.6.15.3l.07-.08-.07.08Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg
              className="header__menu-icon"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.8125 10C17.8125 10.2486 17.7137 10.4871 17.5379 10.6629C17.3621 10.8387 17.1236 10.9375 16.875 10.9375H3.125C2.87636 10.9375 2.6379 10.8387 2.46209 10.6629C2.28627 10.4871 2.1875 10.2486 2.1875 10C2.1875 9.75136 2.28627 9.5129 2.46209 9.33709C2.6379 9.16127 2.87636 9.0625 3.125 9.0625H16.875C17.1236 9.0625 17.3621 9.16127 17.5379 9.33709C17.7137 9.5129 17.8125 9.75136 17.8125 10ZM3.125 5.9375H16.875C17.1236 5.9375 17.3621 5.83873 17.5379 5.66291C17.7137 5.4871 17.8125 5.24864 17.8125 5C17.8125 4.75136 17.7137 4.5129 17.5379 4.33709C17.3621 4.16127 17.1236 4.0625 16.875 4.0625H3.125C2.87636 4.0625 2.6379 4.16127 2.46209 4.33709C2.28627 4.5129 2.1875 4.75136 2.1875 5C2.1875 5.24864 2.28627 5.4871 2.46209 5.66291C2.6379 5.83873 2.87636 5.9375 3.125 5.9375ZM16.875 14.0625H3.125C2.87636 14.0625 2.6379 14.1613 2.46209 14.3371C2.28627 14.5129 2.1875 14.7514 2.1875 15C2.1875 15.2486 2.28627 15.4871 2.46209 15.6629C2.6379 15.8387 2.87636 15.9375 3.125 15.9375H16.875C17.1236 15.9375 17.3621 15.8387 17.5379 15.6629C17.7137 15.4871 17.8125 15.2486 17.8125 15C17.8125 14.7514 17.7137 14.5129 17.5379 14.3371C17.3621 14.1613 17.1236 14.0625 16.875 14.0625Z"
                fill="currentColor"
              />
            </svg>
          )}
        </a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && subLevel <= 1 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <div
          className={`navbar__menu ${
            subLevel === 1 && links.length > 0 && links[0].imageUrl?.length
              ? 'navbar__menu-images'
              : ''
          }`}
          ref={menuRef}
        >
          <div className="navbar__menu-header">
            {contentLink && (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{
                    __html: contentLink.name,
                  }}
                ></span>
              </Fragment>
            )}
          </div>
          {subLevel === 1 && (
            <GetImageLinks
              links={links}
              setClickedIndex={setClickedIndex}
              clickedIndex={clickedIndex}
            />
          )}
          <ul
            className={`navbar__menu-links sub-level-${subLevel} sub-links-count-${
              links?.length || 0
            } ${
              subLevel === 2
                ? getLowerLevelLinkCountClass(links?.length || 0)
                : ''
            }`}
          >
            {links.length > 0 &&
              links.map(
                (link, index) =>
                  hasNameOrChildren(link) && (
                    <Fragment key={`navItem${index}`}>
                      <li className="navbar__item">
                        {subLevel <= 1 && (
                          <NavigationItem
                            links={link.links}
                            contentLink={link}
                            subLevel={subLevel + 1}
                          />
                        )}
                      </li>
                    </Fragment>
                  )
              )}
          </ul>
          {!contentLink && constants && constants.topLinkList && (
            <ul className="navbar__menu-links navbar__top-menu-links">
              {constants.topLinkList.map((link, index) => (
                <li className="navbar__item" key={`topItem${index}`}>
                  <a className="navbar__link" href={link.href}>
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItem;
